import { atom } from "recoil";
export var viewportSlideOpenAtom = atom({
    key: "viewportSlideOpenAtom",
    default: false,
});
